import React, { useContext, useState } from "react";
import { TextField, Button, Alert, CircularProgress } from "@mui/material";
import useAxios from "../../../hooks/useAxios";
import "./RegistrationForm.css";
import { AuthContext } from "../../../context/AuthContext";
import WhiteInputField from '../../common/StyledComponents/WhiteInputField/WhiteInputField';

const RegistrationForm = ({ role, setCurrentStep }) => {
  const { token, setToken } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    email: "",
    phone_number: "",
    password: "",
    password_confirmation: "",
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  const axiosInstance = useAxios();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true); // Enable loading state

    if (formData.password !== formData.password_confirmation) {
        setError("Passwords do not match.");
        setLoading(false); // Disable loading state
        return;
    }

    try {
        const requestData = { ...formData, role };
        if (role === "student") {
            delete requestData.password;
            delete requestData.password_confirmation;
        }
        const response = await axiosInstance.post("/register", requestData);

        // Update token and context
        setToken(response.data.token);
        localStorage.setItem("token", response.data.token);
        setCurrentStep("otp"); // Proceed to OTP step
      } catch (error) {
          console.error(error);

          if (error.response?.data?.errors) {
              // Extract errors and format them into a single string
              const errorMessages = Object.values(error.response.data.errors)
                  .flat() // Flatten nested arrays
                  .join(" ");
              setError(errorMessages); // Set formatted errors
          } else {
              setError(error.response?.data?.message || "Something went wrong.");
          }
      } finally {
          setLoading(false); // Disable loading state
      }
  };


  return (
    <form className="registration-form" onSubmit={handleSubmit}>
      <h2 className="form-title">Register as {role}</h2>
      {error && <Alert severity="error">{error}</Alert>}
      <WhiteInputField
        className="custom-text-field"
        label="Email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        required
        type="email"
      />
      <WhiteInputField
        className="custom-text-field"
        label="Phone Number"
        name="phone_number"
        value={formData.phone_number}
        onChange={handleChange}
        required
      />
      {role !== "student" && (
        <>
          <WhiteInputField
            className="custom-text-field"
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <WhiteInputField
            className="custom-text-field"
            label="Confirm Password"
            type="password"
            name="password_confirmation"
            value={formData.password_confirmation}
            onChange={handleChange}
            required
          />
        </>
      )}
      <Button
        type="submit"
        className="submit-button primary-button"
        disabled={loading} // Disable button during loading
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : "Register"}
      </Button>
      <Button onClick={() => setCurrentStep("role")} className="white-text-button">
        Back to Role Selection
      </Button>
    </form>
  );
};

export default RegistrationForm;
